import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';
import { handleSubmitCreatePipelineOnFounder } from 'components/views/FounderPipeline/_helpers/founderPipeline.events';
import { $view } from 'signals/global.signals';

const FounderCreatePipelineModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-pipeline-create'}
    title="Add Opportunity"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitCreatePipelineOnFounder}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <UniversalInput
      type="select"
      options={$view.value.investorOptions || []}
      name="investorId"
      label="Select Investor"
      className="mb-16"
    />
    <UniversalInput
      type="select"
      name="pipelineStatus"
      label="Pipeline Status"
      options={PIPELINE_STATUS_OPTIONS}
      className="mb-16"
    />
    <UniversalInput
      type="select"
      name="dealId"
      label="Deal"
      options={$view.value.dealOptions || []}
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="previouslyCommitted"
      label="Amount Committed"
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="amountInvested"
      label="Amount Invested"
      className="mb-16"
    />
  </SimpleModal>

);

export default FounderCreatePipelineModal;
